import React from 'react';
import { Page, Document, Text } from '@react-pdf/renderer';
import OrderPrintContent, { styles as printStyles } from '../orders/OrderPrintContent';

const BulkOrderPrintDocument = ({ ordersData }) => (
  <Document>
    {(ordersData || []).map((order, index) => (
      <Page size="A4" style={printStyles.page} key={order.orderId || index} wrap render={({ pageNumber, totalPages }) => (
        <>
          <OrderPrintContent orderData={order} pageNumber={pageNumber} totalPages={totalPages} />
        </>
      )} />
    ))}
  </Document>
);
export default BulkOrderPrintDocument;